import React, { useState, useEffect, useContext } from 'react';
import { Card, Row, Col, CardBody, Collapse } from 'reactstrap';
import styles from './PlanSelection.module.css';
import classNames from 'classnames';
import { ReactComponent as KitchenIcon } from '../../assets/images/range-refrigerator.svg';
import { ReactComponent as LaundryIcon } from '../../assets/images/washer-dryer.svg';
import { ReactComponent as TotalAppIcon } from '../../assets/images/kitchen-appliances.svg';
import { ReactComponent as CheckIcon } from '../../assets/images/checkmark.svg';
import { useMediaQuery } from 'react-responsive';
import InfoTooltip from '../shared/InfoTooltip/InfoTooltip';
import { ReactComponent as Chevron } from '../../assets/images/arrow-cheveron-down.svg';
import { ReactComponent as Phone } from '../../assets/images/Vendor/NJR/phone.svg';
import { useHistory } from 'react-router';
import { SalesContext } from '../contexts/SalesContext';
import ServiceFeeModal from './ServiceFeeModal';
import PlanOptionModal from '../modals/PlanOptions/PlanOptions';
import { BrandingContext } from '../contexts/ContractContext';
import getClientContent from '../_BrandingProvider/brandContent';
import { stripPhoneNumber } from '../shared/util';
import CallBanner from '../shared/CallBanner/CallBanner';
const PlanSelection = ({
    activePlan,
    activeAddPlans,
    selectedAddPlans,
    selectedProduct,
    additionalPlans,
    additionalPlansYearly,
    handleChangePlan,
    plan,
    activeTsf,
    assetsCovered
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const isTablet = useMediaQuery({ query: '(min-width: 768px) and (max-width:1024px)' });
    const [totalPlanValue, setTotalPlanValue] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [showServiceFeeModal, setShowServiceFeeModal] = useState(false);
    const history = useHistory();
    const context = useContext(SalesContext);
    const [totalAddOn, setTotalAddOn] = useState(0);
    const [showPlanOptionModal, setShowPlanOptionModal] = useState(false);
    const branding = useContext(BrandingContext);
    const clientId = branding.contract || 'NJR';
    const { variableText } = getClientContent(clientId);
    const phoneNumber = variableText.customerService.phone;
    const handlePlanOptionModal = (event) => {
        event.preventDefault();
        setShowPlanOptionModal(true);
    };

    console.log(context);

    const appliances = (activePlan) => {
        let items = [];
        let plan = null;
        if (activePlan == 'total') {
            plan = assetsCovered.filter((c) => c.totalBundlePlan == true);
            plan.forEach((item) => {
                items.push(item.name);
            });
        } else if (activePlan == 'kitchen') {
            plan = assetsCovered.filter((c) => c.kitchenPlan == true);
            plan.forEach((item) => {
                items.push(item.name);
            });
        } else if (activePlan == 'laundry') {
            plan = assetsCovered.filter((c) => c.laundryPlan == true);
            plan.forEach((item) => {
                items.push(item.name);
            });
        }

        return items;
    };

    const [selectedPlanOptions, setselectedPlanOptions] = useState({
        plan: activePlan,
        addons: [],
        yearlyAddons: [],
        activeAddOns: activeAddPlans,
        tsf: activeTsf[0],
        selectedProduct,
        selectedAddPlans,
        context
    });

    const bundleTitle = {
        total: 'Total Appliance Bundle',
        kitchen: 'Kitchen Appliances',
        laundry: 'Laundry Appliances'
    };

    const PlanInformation = ({ options }) => {
        return (
            <>
                {options.map((planInfo) => {
                    return (
                        <div className={styles.planInformationOption}>
                            <CheckIcon className={styles.iconImageCheck} />
                            <div>{planInfo}</div>
                        </div>
                    );
                })}
                <div className='text-center'>
                    <button
                        className='btnLink mb-2 mt-3'
                        onClick={handlePlanOptionModal}
                    >
                        Compare Plan Options
                    </button>
                    <div>
                        <div className={styles.helpContact}>
                            <div className={styles.helpContactContent}>
                                <div className={styles.serviceIcon}>
                                    <Phone />
                                </div>
                                <div className={styles.helpPhoneText}>
                                    <div>Need Help?</div>
                                    <div>
                                        Call{' '}
                                        <a
                                            href={`tel:${stripPhoneNumber(phoneNumber)}`}
                                            aria-label='Customer service phone number'
                                            className=' font-weight-bold callLink'
                                        >
                                            {phoneNumber}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const PlanInformationMobile = () => {
        return (
            <div>
                <a
                    className={styles.accordionPlanInfo}
                    title='opens a accordian'
                    role='button'
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span>What's Covered? </span>
                    <Chevron className={classNames(styles.arrow, isOpen ? styles.active : styles.closed)} />
                </a>
            </div>
        );
    };

    const ApplianceIcon = () => {
        switch (activePlan) {
            case 'total':
                return <TotalAppIcon />;
            case 'kitchen':
                return <KitchenIcon />;
            case 'laundry':
                return <LaundryIcon />;
        }
    };

    const onAddonClickHandler = (event, addon, yearlyAddon) => {
        const { addons, yearlyAddons } = selectedPlanOptions;
        const elIndex = addons.findIndex((add) => add.name === addon.name);

        if (elIndex > -1) {
            addons.splice(elIndex, 1);
            yearlyAddons.splice(elIndex, 1);
        } else {
            addons.push(addon);
            yearlyAddons.push(yearlyAddon);
        }
        setselectedPlanOptions({
            ...selectedPlanOptions,
            addons,
            yearlyAddons
        });
    };

    const onTSFButtonClickHandler = (tsfOption) => {
        setselectedPlanOptions({
            ...selectedPlanOptions,
            tsf: tsfOption
        });
        console.log(tsfOption);
    };

    const AddOnOptions = ({ options }) => {
        return options.map((addon, ind) => {
            let selectedTsfName = selectedPlanOptions?.tsf?.name;
            let currentAddOn = additionalPlans?.filter((e) => e.ind == ind);
            let currentYearlyAddOn = additionalPlansYearly?.filter((e) => e.ind == ind);
            //let currentAddOn = additionalPlans?.filter(e => e.name == addon.name) ;
            let price = selectedTsfName == 'lower' ? currentAddOn[0]?.lowerTsfPrice : currentAddOn[0]?.higherTsfPrice;
            const indexOfAddOn = selectedPlanOptions.addons.findIndex((add) => add.name === currentAddOn[0]?.name);
            return (
                <button
                    key={ind}
                    className={`col btn ${styles.addonFeeBtn} ${indexOfAddOn > -1 ? styles.activeBtn : ''}`}
                    onClick={(event) => onAddonClickHandler(event, currentAddOn[0], currentYearlyAddOn[0])}
                >
                    <span>
                        {currentAddOn[0]?.name}{' '}
                        {currentAddOn[0]?.name === 'Cooking Product' && (
                            <InfoTooltip message='Range, Oven or Cooktop' />
                        )}
                    </span>{' '}
                    <span className={styles.feespan}>+${price?.toFixed(2)}/month</span>
                </button>
            );
        });
    };

    const TSFButtons = ({ options }) => {
        return options.map((tsf, ind) => {
            let selectedTsfName = selectedPlanOptions?.tsf?.name;
            return (
                <button
                    key={ind}
                    className={`btn mb-3 ${styles.serviceFeeBtn} ${selectedTsfName === tsf?.name ? styles.activeBtn : ''}`}
                    onClick={() => onTSFButtonClickHandler(tsf)}
                >
                    <span>${tsf?.term} per claim</span>
                    <span>${tsf?.price.toFixed(2)}/month</span>
                </button>
            );
        });
    };

    const calculateTotalPlanPrice = () => {
        let selectedTsfName = selectedPlanOptions?.tsf?.name;
        let planTotal =
            selectedPlanOptions?.tsf?.price == null
                ? selectedProduct?.riskProfile?.totalBundlePrice
                : selectedPlanOptions?.tsf?.price;
        let addonTotal = selectedPlanOptions.addons.reduce((acc, currentAddon) => {
            if (selectedTsfName == 'lower') {
                return acc + currentAddon.lowerTsfPrice;
            } else {
                return acc + currentAddon.higherTsfPrice;
            }
        }, 0);
        setTotalPlanValue(planTotal + addonTotal);
        setTotalAddOn(addonTotal);
    };

    const handleRoute = () => {
        context.updatePlanData({
            plan: plan,
            activePlan: selectedPlanOptions.plan,
            activeAddPlans: selectedPlanOptions.addons,
            activeAddPlansYearly: selectedPlanOptions?.yearlyAddons,
            selectedPlan: selectedPlanOptions.selectedProduct,
            selectedAddPlans: selectedPlanOptions.addons,
            additionalTotal: totalAddOn,
            planTotal: selectedProduct.monthly,
            tsf: selectedPlanOptions.tsf
        });
        history.push('/customerinfo');
    };

    useEffect(() => {
        calculateTotalPlanPrice();
    }, [activePlan, selectedProduct, selectedPlanOptions]);

    return (
        <>
            <Card>
                <CardBody className={styles.planSelectionCard}>
                    <Row className={styles.planSelectionContainer}>
                        <Col className='mb-3'>
                            <div className={styles.basePlan}>
                                <div className={styles.basePlanAsset}>
                                    <ApplianceIcon />
                                </div>
                                <div>
                                    <h1 className='h3'>{bundleTitle[activePlan]}</h1>
                                    {isMobile || isTablet ? (
                                        <PlanInformationMobile />
                                    ) : (
                                        <button
                                            className={classNames('btn btn-secondary')}
                                            onClick={() => handleChangePlan()}
                                        >
                                            Change Plan
                                        </button>
                                    )}
                                </div>
                            </div>
                            {(isMobile || isTablet) && (
                                <Collapse isOpen={isOpen}>
                                    {appliances(activePlan).map((planInfo) => {
                                        return (
                                            <div className={styles.planInformationOption}>
                                                <CheckIcon className={styles.iconImageCheck} />
                                                <div>{planInfo}</div>
                                            </div>
                                        );
                                    })}
                                    <div className='text-center'>
                                        <button
                                            className='btnLink mt-3'
                                            onClick={handlePlanOptionModal}
                                        >
                                            Compare Plan Options
                                        </button>
                                        <div>
                                            <div className={styles.helpContact}>
                                                <div className={styles.helpContactContent}>
                                                    <div className={styles.serviceIcon}>
                                                        <Phone />
                                                    </div>
                                                    <div className={styles.helpPhoneText}>
                                                        <div>Need Help?</div>
                                                        <div>
                                                            Call{' '}
                                                            <a
                                                                href={`tel:${stripPhoneNumber(phoneNumber)}`}
                                                                aria-label='Customer service phone number'
                                                                className=' font-weight-bold callLink'
                                                            >
                                                                {phoneNumber}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            )}
                            <div className={`mt-3 mb-3 ${styles.planInformation}`}>
                                {isMobile || isTablet ? (
                                    <button
                                        className={classNames('btn btn-secondary')}
                                        onClick={() => handleChangePlan()}
                                    >
                                        Change Plan
                                    </button>
                                ) : (
                                    <PlanInformation options={appliances(activePlan)} />
                                )}
                            </div>
                        </Col>
                        <Col>
                            <div className={styles.serviceFeeamountContainer}>
                                <h2 className='h4 mb-0'>Choose your service fee amount.</h2>
                                <a
                                    onClick={() => setShowServiceFeeModal(true)}
                                    className={`mb-3 ${styles.link}`}
                                >
                                    What is a service fee?
                                </a>
                                <TSFButtons options={activeTsf} />
                                {activePlan != 'laundry' && (
                                    <h2 className='h4 mt-3'>Want to add secondary products?</h2>
                                )}
                                <div className={`${styles.addonsOptionsPriceContainer}`}>
                                    {activePlan != 'laundry' && <AddOnOptions options={additionalPlans} />}
                                </div>
                                <div className={styles.totalPlanContainer}>
                                    <p className={styles.totalAmount}>Total: ${totalPlanValue.toFixed(2)}/month</p>
                                    <button
                                        className={classNames('btn btn-primary')}
                                        onClick={handleRoute}
                                    >
                                        Proceed to Checkout
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            {showPlanOptionModal && (
                <PlanOptionModal
                    isOpen={showPlanOptionModal}
                    centered={true}
                    toggle={() => setShowPlanOptionModal(!showPlanOptionModal)}
                    isHome={false}
                />
            )}
            {showServiceFeeModal && (
                <ServiceFeeModal
                    onCloseModal={() => setShowServiceFeeModal(false)}
                    tsf={activeTsf}
                />
            )}
        </>
    );
};

export default PlanSelection;
